interface Messages {
  [key: string]: { [key: string]: string };
}

export const messages: Messages = {
  associateBooking: {
    firstName_isNotEmpty: "First name is required",
    firstName_matches: "First name may contain only letters, dots, and hyphens",
    firstName_minLength: "First name must be at least 3 characters",
    firstName_maxLength: "First name must not exceed 30 characters",

    lastName_isNotEmpty: "Last name is required",
    lastName_matches: "Last name may contain only letters, dots, and hyphens",
    lastName_minLength: "Last name must have at least 1 character",
    lastName_maxLength: "Last name must not exceed 30 characters",

    addressLine1_isNotEmpty: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",

    landmark_maxLength: "Landmark must not exceed 50 characters",

    gender_isNotEmpty: "Gender is required",

    companyName_isNotEmpty: "Company name is required",
    companyName_maxLength: "Company name must not exceed 60 characters",

    gstNumber_test: "GST number must have 15 characters",

    email_isNotEmpty: "Email is required",
    email_matches: "Please enter a valid email address",
    email_maxLength: "Email must not exceed 70 characters",

    pincode_isNotEmpty: "Pincode is required",
    pincode_matches: "Pincode must be a 6-digit number",

    city_isNotEmpty: "City is required",
    city_maxLength: "City must not exceed 50 characters",

    state_isNotEmpty: "State is required",
    state_maxLength: "State must not exceed 50 characters",

    phone_matches: "Contact number must be a 10-digit mobile number",

    pan_maxLength: "PAN number must have 10 characters",
    tan_maxLength: "TAN number must have 10 characters",

    court_isUnavailable: "No courts are available",

    sport_isNotEmpty: "Sport is required",
    startDate_isNotEmpty: "Start date is required",
    endDate_isNotEmpty: "End date is required",
    slots_isNotEmpty: "Slots are required",

    facility_select: "Please select a facility",
  },
  coachingSessionBooking: {
    phone_maxLength: "Contact number must be a 10-digit mobile number",
    firstName_min_max: "First name must be between 3 to 30 characters",
    firstName_matches: "First name must contain alphabets, dots, and hyphens only",
    lastName_min_max: "Last name must be between 1 to 30 characters",
    lastName_matches: "Last name must contain alphabets, dots, and hyphens only",

    gender_required: "Gender is required",
    dateOfBirth_required: "Birth date is required",

    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine1_required: "Address line 1 is required",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",

    landmark_maxLength: "Landmark must not exceed 50 characters",

    country_maxLength: "Country must not exceed 50 characters",

    city_maxLength: "City must not exceed 50 characters",
    city_required: "City is required",

    state_maxLength: "State must not exceed 50 characters",
    state_required: "State is required",

    pincode_required: "Pincode is required",
    pincode_length: "Pincode must be 6 digits",

    email_required: "Email is required",
    email_matches: "Please enter a valid email address",

    something_wrong: "Something went wrong",

    facility_select: "Please select a facility",

    image_match_type: "Invalid image type",
    image_size: "File size must be less than 5 MB",
  },
  customerCoachingSessionBooking: {
    something_wrong: "Something went wrong",
    facility_select: "Please select a facility",

    gender_required: "Gender is required",

    email_required: "Email is required",
    email_matches: "Please enter a valid email address",

    dateOfBirth_required: "Birth date is required",
    dateOfBrith_isNotnfuture: "Birth date cannot be in the future",

    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine1_required: "Address line 1 is required",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",

    landmark_maxLength: "Landmark must not exceed 50 characters",

    city_required: "City is required",
    state_required: "State is required",

    pincode_length: "Pincode must be 6 digits",

    firstName_min_max_length: "First name must be between 3 to 30 characters",
    firstName_matches: "First name must contain alphabets, dots, and hyphens only",

    lastName_min_max_length: "Last name must be between 1 to 30 characters",
    lastName_matches: "Last name must contain alphabets, dots, and hyphens only",

    whatsApp_min_max_length: "WhatsApp number must be 10 digits",
    whatsApp_required: "WhatsApp number is required",

    schoolName_maxLength: "School name must not exceed 100 characters",
    schoolName_matches: "Please enter a valid school name",

    parentName_maxLength: "Parent name must not exceed 100 characters",
    parentName_matches: "Please enter a valid parent name",

    sport_required: "Sport is required",
    session_required: "Session is required",
    numberofSession_required: "Number of sessions per week is required",

    days_required: "Days are required",

    weeks_for_booking_required: "Weeks for booking are required",
    weeks_for_booking_length: "Weeks for booking must not exceed 2 characters",

    startDate_required: "Start date is required",
  },
  stocks: {
    name_required: "Product name is required",
    name_matches: "Product name should contain alphabets, numbers, spaces, hyphens, dots, @, commas, brackets, slash, and ampersand symbols only",
    name_minLength: "Product name must be at least 3 characters long",
    name_maxLength: "Product name must not exceed 30 characters",

    hsnNumber_required: "HSN code is required",
    hsnNumber_min_max_length: "HSN code must be 6 to 8 digits",

    totalQuantity_required: "Product quantity is required",
    totalQuantity_length: "Product total quantity must be exactly 4 digits",
    totalQuantity_maxLength: "Quantity must not exceed 4 digits",
    productQuantity_length: "Product quantity must not exceed 4 digits",

    costPrice_required: "Purchased price per unit is required",
    costPrice_match: "Up to two decimal places are allowed",
    costPrice_matches: "Up to two decimal places are allowed",
    costPrice_maxLength: "Purchased price per unit must not exceed 10 digits",
    costPrice_minValue: "Purchased price per unit must be at least 1",

    sellingPricePerUnit_required: "Selling price per unit is required",
    sellingPrice_matches: "Up to two decimal places are allowed",
    sellingPrice_maxLength: "Selling price per unit must not exceed 10 digits",

    facility_select: "Please select a facility",

    IGST_required: "IGST is required",
    IGST_valueType: "IGST must be in format xx.xx",

    CGST_required: "CGST is required",
    CGST_valueType: "CGST must be in format xx.xx",

    SGST_required: "SGST is required",
    SGST_valueType: "SGST must be in format xx.xx",

    remarkText_required: "Remark is required",
    remark_maxLength: "Remark must not exceed 200 characters",

    availableQuantity_required: "Quantity is required",

    sellingPrice_required: "Selling price is required",
    status_required: "Status is required",

    serviceCostPrice_maxLength: "Product value must not exceed 10 digits",
    serviceCostPrice_match: "Product value is invalid",
    serviceCostPrice_minLength: "Product value must be greater than 0",
    serviceCostPrice_required: "This field is required",

    rentingPrice_maxLength: "Charge per unit must not exceed 10 digits",
    rentingPrice_matches: "Charge per unit is invalid",
    rentingPrice_required: "This field is required",

    sacCode_length: "SAC must be of 6 digits",

    serviceTotalQuantity_required: "This field is required",
    facilityID_required: "Facility ID is required",

    something_wrong: "Something went wrong",
    serviceName_required: "This field is required",
  },
  notification: {
    templateName_required: "Template name is required",
    templateName_matches: "Template name should contain alphabets, numbers, spaces, hyphens, dots, @, commas, brackets, slash, and ampersand symbols only",
    templateName_maxLength: "Template name must not exceed 30 characters",

    title_matches: "Title should contain alphabets, numbers, spaces, hyphens, dots, @, commas, brackets, slash, and ampersand symbols only",
    title_maxLength: "Title must not exceed 100 characters",
    title_required: "Title is required",

    message_maxLength: "Message must not exceed 300 characters",
    message_required: "Message is required",

    startDate_required: "Start date is required",
    endDate_required: "End date is required",

    sendToUsers_required: "Send to users is required",
    sendOnDays_required: "Send on days is required",
  },
  offers: {
    offerSports_required: "Sport is required",

    name_matches: "Event name should contain alphabets, numbers, spaces, hyphens, dots, @, commas, brackets, slash, and ampersand symbols only",
    name_min_max_length: "Event name must be between 3 to 30 characters",

    startDate_required: "Start date is required",
    endDate_required: "End date is required",

    startTime_required: "Start time is required",
    endTime_required: "End time is required",

    discountPercent_maxLength: "Discount percentage must be between 0 and 100",
    discountPercent_valueType: "Discount percentage must be in the format xx.xx",
  },
  settings: {
    sessionEndDateLimit_required: "Session end date limit is required",

    rewardPointsPercent_valueType: "Reward points percentage must be in the format xx.xx",
    rewardPointsPercent_required: "Reward points percentage is required",

    minApplicableRewardPoints_required: "Minimum applicable reward points is required",
    minRewardPointsToClaim_required: "Minimum reward points to claim is required",
    dashboardDefaultInterval_required: "Dashboard default interval is required",

    courtIgst_required: "Court IGST is required",
    courtIgst_valueType: "Court IGST must be in the format xx.xx",

    courtCgst_required: "Court CGST is required",
    courtCgst_valueType: "Court CGST must be in the format xx.xx",

    courtSgst_required: "Court SGST is required",
    courtSgst_valueType: "Court SGST must be in the format xx.xx",

    courtSacCode_length: "SAC code must be 6 digits",

    sessionIgst_required: "Session IGST is required",
    sessionIgst_valueType: "Session IGST must be in the format xx.xx",

    sessionCgst_required: "Session CGST is required",
    sessionCgst_valueType: "Session CGST must be in the format xx.xx",

    sessionSgst_required: "Session SGST is required",
    sessionSgst_valueType: "Session SGST must be in the format xx.xx",

    sessionSacCode_length: "SAC code must be of 6 digits",
  },
  printInvoice: {
    try_aftre_some_time: "Try again after some time",
  },
  auth: {
    firstName_isNotEmpty: "First name is required",
    firstName_matches: "First name must contain alphabets, dots, and hyphens only",
    firstName_minLength: "First name must be at least 3 characters",
    firstName_maxLength: "First name must not exceed 30 characters",

    lastName_isNotEmpty: "Last name is required",
    lastName_matches: "Last name must contain alphabets, dots, and hyphens only",
    lastName_minLength: "Last name must have at least 1 character",
    lastName_maxLength: "Last name must not exceed 30 characters",

    gender_isNotEmpty: "Gender is required",

    phone_isNotEmpty: "Mobile number is required",
    phone_matches: "Mobile number must be 10 digits",

    email_invalid_email: "Please enter a valid email address",
    email_maxLength: "Email must not exceed 70 characters",

    password_isNotEmpty: "Password is required",
    password_minLength: "Password must be at least 8 characters",
    password_maxLength: "Password must not exceed 15 characters",
    password_matches: "Password must not contain spaces",

    cpassword_matches: "Confirm password must not contain spaces",
    cpassword_oneof: "Passwords do not match",

    addressLine1_isNotEmpty: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",

    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",

    landmark_maxLength: "Landmark must not exceed 50 characters",

    pincode_isNotEmpty: "Pincode is required",
    pincode_maxLength: "Pincode must be of 6 digits",

    city_isNotEmpty: "City is required",
    city_maxLength: "City must not exceed 50 characters",

    state_isNotEmpty: "State is required",
    state_maxLength: "State must not exceed 50 characters",

    otpFor_isEnum: "Mobile number must be 10 digits",
    verifyBy_required: "Verify option is required",
  },
  profile: {
    password_oldNotEmpty: "Old password is required",
    password_newNotEmpty: "New password is required",
    password_same: "New password must not be the same as old password",
    password_matches: "Password must not contain spaces",

    phone_matches: "Phone number must be of 10 digits",
    email_matches: "Please enter a valid email address",

    firstName_isNotEmpty: "First name is required",
    firstName_minLength: "First name must contain at least 3 characters",
    firstName_maxLength: "First name must not exceed 30 characters",

    lastName_isNotEmpty: "Last name is required",
    lastName_minLength: "Last name must contain at least 1 character",
    lastName_maxLength: "Last name must not exceed 30 characters",

    addressLine1_isNotEmpty: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",

    landmark_maxLength: "Landmark must not exceed 50 characters",

    pincode_isNotEmpty: "Pincode is required",
    pincode_maxLength: "Pincode must be 6 digits",

    city_isNotEmpty: "City is required",
    city_maxLength: "City must not exceed 50 characters",

    state_isNotEmpty: "State is required",
    gender_isNotEmpty: "Gender is required",

    image_isValid: "Please upload a valid image",
    image_isNotValid: "Invalid image type",

    file_size: "Invalid file size",
    file_fixSize: "File size must be less than 5 MB",

    aadharNumber_isNotEmpty: "Aadhaar number is required",
    aadharNumber_maxLength: "Aadhaar number must be 12 digits",
  },
  facilities: {
    addressLine1_isNotEmpty: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",
    landmark_maxLength: "Landmark must not exceed 50 characters",

    facilityName_isNotEmpty: "Facility name is required",
    facility_matches: "Facility name should contain alphabets, numbers, spaces, hyphens, dots, @, commas, brackets, slash, and ampersand symbols only",

    facility_minLength: "Facility name must be at least 3 characters",
    facility_maxLength: "Facility name must not exceed 30 characters",

    pincode_isNotEmpty: "Pincode is required",
    pincode_maxLength: "Pincode must be of 6 digits",

    city_isNotEmpty: "City is required",
    city_maxLength: "City must not exceed 50 characters",

    state_isNotEmpty: "State is required",
    state_maxLength: "State must not exceed 30 characters",

    latitude_name: "Please enter latitude",
    latitude_maxLength: "Latitude must not exceed 12 characters",
    latitude_matches: "Please enter a valid latitude",

    longitude_name: "Please enter longitude",
    longitude_maxLength: "Longitude must not exceed 12 characters",
    longitude_matches: "Please enter a valid longitude",
  },
  sports: {
    name_isNotEmpty: "Sport name is required",
    name_matches: "Sport name should contain alphabets, numbers, spaces, hyphens, dots, at signs, commas, round brackets, slashes, and ampersands only",
    name_length: "Sport name must be between 3 and 30 characters",
    rules_isNotEmpty: "Rule subject is required",
    rules_length: "Rule subject must not exceed 200 characters",
    invalid_file_format: "Please upload a PNG or JPG file",
    invalid_file_size: "File size must be less than 100 KB",
    image_isNotEmpty: "Sport image is required",
  },
  courts: {
    name_isNotEmpty: "Court name is required",
    name_matches: "Court name should contain alphabets, numbers, spaces, hyphens, dots, at signs, commas, round brackets, slashes, and ampersands only",
    name_minLength: "Court name must be at least 2 characters",
    name_maxLength: "Court name must not exceed 10 characters",
    sport_name: "Please select a sport",
    sport_nameIsNotEmpty: "Sport is required",
    preBookingMaxDays_isNotEmpty: "Pre-booking days are required",
    preBookingMaxDays_max: "Pre-booking max days must be less than or equal to 365",
    openTime_isNotEmpty: "Open time is required",
    closeTime_isNotEmpty: "Close time is required",
    rates_size: "Rates must contain at least 3 digits",
    slotDuration_isNotEmpty: "Slot start time and end time already exist",
    ratePerSlot_isNotEmpty: "Rate per slot is required",
    startTime_isNotEmpty: "Start time is required",
    endTime_isNotEmpty: "End time is required",
    error_select: "Please select a facility",
    sport_required: "Sport is required",
    court_required: "Court is required",
    bookingType_required: "Booking type is required",
    sport_select: "Please select a sport",
    slot_minLength: "Minimum 2 slots must be selected",
    slot_minLengthOne: "Only 1 slot must be selected",
    facility_required: "Please select a facility",
  },
  users: {
    firstName_isNotEmpty: "First name is required",
    firstName_matches: "First name must contain alphabets, dots, and hyphens only",
    firstName_minLength: "First name must be at least 3 characters",
    firstName_maxLength: "First name must not exceed 30 characters",
    lastName_isNotEmpty: "Last name is required",
    lastName_matches: "Last name must contain alphabets, dots, and hyphens only",
    lastName_minLength: "Last name must have at least 1 character",
    lastName_maxLength: "Last name must not exceed 30 characters",
    gender_isNotEmpty: "Gender is required",
    phone_isNotEmpty: "Mobile number is required",
    phone_matches: "Phone number must be 10 digits",
    email_isNotEmpty: "Email is required",
    email_invalid_email: "Please enter a valid email address",
    email_maxLength: "Email must not exceed 70 characters",
    aadharNumber_isNotEmpty: "Aadhaar number is required",
    aadharNumber_maxLength: "Aadhaar number must be exactly 12 digits",
    aadharNumber_exactly: "Aadhaar number must be exactly 12 digits",
    addressLine1_isNotEmpty: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",
    landmark_maxLength: "Landmark must not exceed 50 characters",
    pincode_isNotEmpty: "Pincode is required",
    pincode_maxLength: "Pincode must be 6 digits",
    city_isNotEmpty: "City is required",
    city_maxLength: "City must not exceed 50 characters",
    state_isNotEmpty: "State is required",
    state_maxLength: "State must not exceed 50 characters",
    image_isValid: "Please upload a valid image",
    image_isNotValid: "Invalid image type",
    file_size: "Invalid file size",
    file_fixSize: "File size must be less than 5 MB",
    password_isNotEmpty: "Password is required",
    password_minLength: "Password must be at least 8 characters",
    password_maxLength: "Password must not exceed 15 characters",
    password_matches: "Password must not contain spaces",
    cpassword_matches: "Confirm password must not contain spaces",
    cpassword_oneof: "Passwords do not match",
    role_isNotEmpty: "Role is required",
  },
  coaching: {
    court_isNotEmpty: "Courts are not available",
    rate_minLength: "Rate per session must be greater than or equal to 100",
    discountPercent: "Discount percentage is required",
    noOfWeeks: "Weeks for booking are required",
    discountPercent_length: "Discount percentage must be between 0 and 100",
    discountPercent_digit: "Discount percentage must be 4 digits in xx.xx format",
    court_discount: "Please add discount and weeks for booking",
    subject_isNotEmpty: "Rule subject is required",
    subject_length: "Rule subject must not exceed 200 characters",
    session_maxLength: "Session name must not exceed 30 characters",
    session_matches: "Session name should contain alphabets, numbers, spaces, hyphens, dots, at signs, commas, round brackets, slashes, and ampersands only",
    session_isNotEmpty: "Session name is required",
    session_startDate: "Start date is required",
    session_slot: "At least one slot is required",
    session_maximumAttendees: "Maximum number of attendees must not exceed 5 digits",
    session_maxiIsNotEmpty: "Maximum number of attendees is required",
    minimum_weeks: "Minimum number of weeks to attend is required",
    court_required: "Court is required",
    court_coachName: "Coach name is required",
    court_sport: "Sport is required",
    court_charges: "Charges are not added yet",
    facility_isNotEmpty: "Please select a facility",
    startDate_endDate_isNotEmpty: "Please select start date and end date",
  },
  courtbooking: {
    firstName_isNotEmpty: "First name is required",
    firstName_matches: "First name must contain alphabets, dots, and hyphens only",
    firstName_minLength: "First name must be at least 3 characters",
    firstName_maxLength: "First name must not exceed 30 characters",
    lastName_isNotEmpty: "Last name is required",
    lastName_matches: "Last name must contain alphabets, dots, and hyphens only",
    lastName_minLength: "Last name must have at least 1 character",
    lastName_maxLength: "Last name must not exceed 30 characters",
    phone_isNotEmpty: "Mobile number is required",
    phone_matches: "Phone number must be of 10 digits",
    addressLine1_isNotEmpty: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",
    landmark_maxLength: "Landmark must not exceed 50 characters",
    gender_isNotEmpty: "Gender is required",
    email_isNotEmpty: "Email is required",
    email_invalid_email: "Please enter a valid email address",
    email_maxLength: "Email must not exceed 70 characters",
    gstNumber_minLength: "GST number must have 15 characters",
    gstNumber_maxLength: "GST number must have 15 characters",
    pincode_isNotEmpty: "Pincode is required",
    pincode_maxLength: "Pincode must be 6 digits",
    city_isNotEmpty: "City is required",
    city_maxLength: "City must not exceed 50 characters",
    state_isNotEmpty: "State is required",
    state_maxLength: "State must not exceed 50 characters",
    company_isNotEmpty: "Company name is required",
    comapny_maxLength: "Company name must not exceed 60 characters",
    company_matches: "Company name must contain alphabets, dots, spaces, and hyphens only",
  },
  posAdmin: {
    email_required: "Email is required",
    email_matches: "Please enter a valid email address",
    phoneNumber_maxLength: "Mobile number must be 10 digits",
    firstName_matches: "First name must contain alphabets, dots, and hyphens only",
    firstName_maxLength: "First name must not exceed 30 characters",
    firstName_minLength: "First name must be at least 3 characters",
    firstName_required: "First name is required",
    lastName_matches: "Last name must contain alphabets, dots, and hyphens only",
    lastName_maxLength: "Last name must not exceed 30 characters",
    lastName_minLength: "Last name must be at least 3 characters",
    lastName_required: "Last name is required",
    gstnumber_length: "GST number must have 15 characters",
    addressLine1_required: "Address line 1 is required",
    addressLine1_maxLength: "Address line 1 must not exceed 50 characters",
    addressLine2_maxLength: "Address line 2 must not exceed 50 characters",
    landmark_maxLength: "Landmark must not exceed 50 characters",
    city_required: "City is required",
    city_maxLength: "City must not exceed 50 characters",
    state_required: "State is required",
    state_maxLength: "State must not exceed 50 characters",
    pincode_length: "Pincode must be 6 digits",
    startDate_valid: "Please select a valid start time",
    gst_match: "GST number must be numeric",
    city_match: "City must contain only letters",
    phone_match: "Pincode must be numeric",
  },
  resetPassword: {
    password_match: "Passwords do not match",
    password_isNotContainSpace: "Password must not contain spaces",
    password_min_max_length: "Password must be between 8 to 16 characters",
  },
  error: {
    internal_server_error: "Internal server error",
  },
};
